export default __webpack_public_path__ + "static/media/AV8Loading.d19ddde9.gif";